/* LightSeek news listing + article helpers */
(function () {
  'use strict';

  /* ---------- listing: page size + jump ---------- */
  var listPage = document.querySelector('.ls-news-page');
  if (listPage) {
    var sizeSelect = listPage.querySelector('.page-size-select');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('page_size', sizeSelect.value);
        url.searchParams.set('page', '1');
        window.location.assign(url.toString());
      });
    }
    var jumpInput = listPage.querySelector('.page-jump-input');
    if (jumpInput) {
      var maxPage = parseInt(jumpInput.getAttribute('max'), 10) || 1;
      var jump = function () {
        var target = parseInt(jumpInput.value, 10);
        if (!target || target < 1) return;
        target = Math.min(target, maxPage);
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(target));
        window.location.assign(url.toString());
      };
      jumpInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') jump();
      });
      jumpInput.addEventListener('blur', jump);
    }
  }

  /* ---------- article: table of contents ---------- */
  var articlePage = document.querySelector('.ls-article-page');
  if (articlePage) {
    var content = articlePage.querySelector('.news-detail-content');
    var toc = articlePage.querySelector('.news-toc[data-toc]');
    if (content && toc) {
      var headings = content.querySelectorAll('h2');
      if (headings.length >= 2) {
        var list = document.createElement('ol');
        list.className = 'news-toc-list';
        Array.prototype.forEach.call(headings, function (h, i) {
          if (!h.id) h.id = 'guide-sec-' + (i + 1);
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent.trim();
          li.appendChild(a);
          list.appendChild(li);
        });
        toc.appendChild(list);
        toc.hidden = false;
      }
    }
  }
})();
